import { useState } from "react";
import { createReview } from "../../../../../../services/reviewService";

export default function RatingForm({ itemId }) {
  const [userName, setUserName] = useState("");
  const [message, setMessage] = useState("");
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    setError("");
    setSuccess("");

    if (!userName.trim() || !message.trim() || rating === 0) {
      setError("All fields are required");
      return;
    }

    setLoading(true);

    try {
      createReview({
        name: userName, 
        trip: itemId,
        stars: rating,
        message: message,
        date: new Date().toLocaleDateString()
      }).then((data) => {
        setSuccess("Thanks for your review");
        setUserName("");
        setMessage("");
        setRating(0);
      })
    } catch (err) {
      setError("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} style={styles.form}>
      <h3 style={styles.title}>Leave a Review</h3>

      <input
        type="text"
        placeholder="Your name"
        value={userName}
        onChange={(e) => setUserName(e.target.value)}
        style={styles.input}
      />

      <textarea
        placeholder="Your message"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        rows={4}
        style={styles.textarea}
      />

      <div style={styles.stars}>
        {[1, 2, 3, 4, 5].map((value) => (
          <span
            key={value}
            onClick={() => setRating(value)}
            onMouseEnter={() => setHover(value)}
            onMouseLeave={() => setHover(0)}
            style={{
              ...styles.star,
              color: (hover || rating) >= value ? "#f59e0b" : "#d1d5db",
            }}
          >
            ★
          </span>
        ))}
      </div>

      {error && <p style={styles.error}>{error}</p>}
      {success && <p style={styles.success}>{success}</p>}

      <button
        type="submit"
        disabled={loading}
        style={{
          ...styles.button,
          opacity: loading ? 0.6 : 1,
        }}
      >
        {loading ? "Submitting…" : "Submit Review"}
      </button>
    </form>
  );
}


const styles = {
  form: {
    maxWidth: "400px",
    padding: "20px",
    border: "1px solid #e5e7eb",
    borderRadius: "10px",
    background: "#fff",
  },
  title: {
    marginBottom: "12px",
    fontSize: "18px",
    fontWeight: "600",
    color: "#111827",
  },
  input: {
    width: "100%",
    padding: "10px",
    marginBottom: "10px",
    borderRadius: "6px",
    color: "black",
    border: "1px solid #d1d5db",
  },
  textarea: {
        color: "black",
    width: "100%",
    padding: "10px",
    marginBottom: "12px",
    borderRadius: "6px",
    border: "1px solid #d1d5db",
    resize: "vertical",
  },
  stars: {
    display: "flex",
    gap: "6px",
    fontSize: "26px",
    marginBottom: "12px",
    cursor: "pointer",
  },
  star: {
    transition: "color 0.15s ease",
  },
  button: {
    width: "100%",
    padding: "10px",
    background: "#2563eb",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    fontWeight: "600",
    cursor: "pointer",
  },
  error: {
    color: "#dc2626",
    marginBottom: "8px",
    fontSize: "14px",
  },
  success: {
    color: "#16a34a",
    marginBottom: "8px",
    fontSize: "14px",
  },
};

// import { useState } from "react";
// import { createReview } from "../../../../../../services/reviewService";
// import "./review.scss";

// export default function RatingForm({ itemId }) {
//   const [userName, setUserName] = useState("");
//   const [message, setMessage] = useState("");
//   const [rating, setRating] = useState(0);
//   const [hover, setHover] = useState(0);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [success, setSuccess] = useState("");

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     setError("");
//     setSuccess("");

//     if (!userName.trim() || !message.trim() || rating === 0) {
//       setError("All fields are required");
//       return;
//     }

//     setLoading(true);

//     try {
//       await createReview({
//         name: userName,
//         trip: itemId,
//         stars: rating,
//         message: message,
//         date: new Date().toLocaleDateString()
//       });

//       setSuccess("Thanks for your review");
//       setUserName("");
//       setMessage("");
//       setRating(0);
//     } catch (err) {
//       setError("Something went wrong");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <form className="review-form" onSubmit={handleSubmit}>
//       <h3 className="form-title">Leave a Review</h3>

//       <input
//         type="text"
//         placeholder="Your name"
//         value={userName}
//         onChange={(e) => setUserName(e.target.value)}
//       />

//       <textarea
//         placeholder="Your message"
//         value={message}
//         onChange={(e) => setMessage(e.target.value)}
//         rows={4}
//       />

//       <div className="rating-stars">
//         {[1, 2, 3, 4, 5].map((value) => (
//           <span
//             key={value}
//             onClick={() => setRating(value)}
//             onMouseEnter={() => setHover(value)}
//             onMouseLeave={() => setHover(0)}
//             className={(hover || rating) >= value ? "active-star" : ""}
//           >
//             ★
//           </span>
//         ))}
//       </div>

//       {error && <p className="form-error">{error}</p>}
//       {success && <p className="form-success">{success}</p>}

//       <button type="submit" disabled={loading}>
//         {loading ? "Submitting…" : "Submit Review"}
//       </button>
//     </form>
//   );
// }

